import React from "react"
import { LuCheck } from "react-icons/lu"

// Import CSS module
import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import SolidBtn from "@fuse/sharedComponents/buttons/SolidBtn"

import { useStripeSuccess } from "@fuse/pages/eventSignUp/BuyTickets/StripeSuccess/useStripeSuccess"

import SuccessShower from "@fuse/assets/images/eventSignUp/img-success-shower.svg"

import styles from "./SuccessAnimation.module.css"

const SuccessAnimation: React.FC = () => {
  const { show, flyerImage, onContinueToEvent, textToShow } = useStripeSuccess()

  return (
    <BackgroundWrapper bgImage={flyerImage} className="min-h-screen">
      <BlurWrapper
        overlayOpacityDefault="75"
        overlayColorDefault="dark"
        className="min-h-screen items-center justify-center flex"
      >
        <div className="flex items-center justify-center flex-col">
          <div className="h-28 w-28 md:h-32 md:w-32 rounded-full bg-white/15 flex items-center justify-center max-w-sm md:max-w-lg">
            <img
              src={SuccessShower}
              alt="SuccessShower"
              className={`absolute h-60 w-60 md:h-80 md:w-80 mr-4 transition-all duration-1000 ease-out
          ${show ? "opacity-100 visibility-visible " + styles.animateScaleUpFromCenter : "opacity-0 visibility-hidden"}
        `}
            />
            <div className="h-20 w-20 md:h-24 md:w-24 rounded-full bg-white/15 flex items-center justify-center">
              <LuCheck className="h-14 w-14 md:h-20 md:w-20" color="white" />
            </div>
          </div>

          <div
            className={`max-w-sm md:max-w-lg mt-20 transition-all duration-500 px-4 ease-out
          ${show ? "opacity-100 visibility-visible " + styles.animateScaleUpFromCenter : "opacity-0 visibility-hidden"}
        `}
          >
            <p className="text-2xl md:text-3xl text-white">
              {textToShow?.header}
            </p>
            <p className="text-sm md:text-md text-white/30 mt-2 max-w-sm">
              {textToShow.subTitle}
            </p>
          </div>

          <div
            className={`flex items-center justify-center mt-10 max-w-xs md:max-w-lg w-full self-center transition-all duration-500 ease-out
          ${show ? "opacity-100 visibility-visible " + styles.animateScaleUpFromCenter : "opacity-0 visibility-hidden"}
        `}
          >
            <SolidBtn
              size="lg"
              className="px-6 lg:px-8 w-full bg-white/15"
              onClick={onContinueToEvent}
            >
              Continue
            </SolidBtn>
          </div>
        </div>
      </BlurWrapper>
    </BackgroundWrapper>
  )
}

export default SuccessAnimation
